var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 92,
    viewBox: "0 0 105 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M91.5815 61.3332H13.9104V15.3332H91.5815M91.5815 7.6665H13.9104C9.12068 7.6665 5.28027 11.0782 5.28027 15.3332V61.3332C5.28027 63.3665 6.18952 65.3165 7.80798 66.7543C9.42644 68.1921 11.6215 68.9998 13.9104 68.9998H44.1158V76.6665H35.4857V84.3332H70.0062V76.6665H61.376V68.9998H91.5815C93.8703 68.9998 96.0654 68.1921 97.6839 66.7543C99.3023 65.3165 100.212 63.3665 100.212 61.3332V15.3332C100.212 13.2998 99.3023 11.3498 97.6839 9.91202C96.0654 8.47424 93.8703 7.6665 91.5815 7.6665Z",
    fill: "#7E1A77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.44426609d1532d9c70173d8f8159b3e1.svg";
export { ForwardRef as ReactComponent };